export const GetBaseURL = () => {
  return (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
};
